import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MessageSquare, Clock } from 'lucide-react';
import { categoryLabels, ForumThreadRow } from './forumLabels';

type Props = {
  thread: ForumThreadRow;
  index?: number;
};

function excerpt(text: string, max = 90) {
  const t = text.replace(/\s+/g, ' ').trim();
  return t.length <= max ? t : `${t.slice(0, max)}…`;
}

const ForumPreviewCard: React.FC<Props> = ({ thread, index = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ delay: index * 0.08 }}
  >
    <Link to={`/forum/thread/${thread._id}`} className="forum-preview-card glow-card">
      <span className="forum-badge">{categoryLabels[thread.category] || thread.category}</span>
      <h3>{thread.title}</h3>
      <p>{excerpt(thread.content)}</p>
      <div className="forum-preview-card__meta">
        <span>{thread.author?.name || 'Üye'}</span>
        <span>
          <MessageSquare size={12} /> {thread.replyCount}
        </span>
        <span>
          <Clock size={12} /> {new Date(thread.createdAt).toLocaleDateString('tr-TR')}
        </span>
      </div>
    </Link>
  </motion.div>
);

export default ForumPreviewCard;
